import { HAFile } from "./HAFile";
import { Div } from "../../Div";
import { Img } from "../../Img";
import { Tag } from "../../Tag";
import { toMap } from "../../../../../HA";

export class MultiMedia extends HAFile {

    public getType() {
        return "MultiText";
    }

    public getChoices() {
        const r = new Map();
        const choices = this.getSelected();

        if (choices) {
            choices.forEach((c: any) => {
                if (c instanceof Tag) {
                    r.set(r.size, toMap({item: c, s: this.isSelected(c)}));
                    return;
                }
                r.set(c, toMap({v: c, s: this.isSelected(c)}));
            });
        }

        return r;
    }

    protected getChoicesLength() {
        return 0;
    }

    protected isSelected(value: any) {
        return true;
    }

    protected add(item: any) {
        if (typeof item === "string") {
            item = new Div(new Img(toMap({class: "thumb", src: item})));
        }
        super.add(item);
    }
}
